import React from 'react'
import {
    IonPage,
    IonContent,
    IonDatetime,
    IonSelect,
    IonSelectOption,
    IonButton,
} from '@ionic/react'
import dayjs from 'dayjs'
import { Formik, Form } from 'formik'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import Header from '../../components/Header'
import { AddIcon, ContactAddIcon, DeleteIcon } from '../../conf/images'
import RadioItem from '../../components/RadioItem'
import Toast, { ToastProps } from '../../components/Toast'
import { useHistory, useLocation } from 'react-router'
import { BotPushServiceSetting } from '../BotPushService'
import { savePushServicesItem } from '../../service/api/bot'
import {
    PushServiceName,
    PushServiceContactList,
    PushServiceTime,
} from '../../components/PushServiceComponents'
import './index.css'

dayjs.extend(customParseFormat)

const BotPushServiceDetail: React.FC = () => {
    const history = useHistory()
    const location = useLocation<{ item: BotPushServiceSetting }>()
    const [showGroup, setShowGroup] = React.useState(false)
    const [shwoFriend, setShowFriend] = React.useState(false)
    const [toastOptions, setToastToastOptions] = React.useState<ToastProps>({
        isOpen: false,
        message: '',
        position: 'top',
        color: 'error',
        duration: 1500,
    })

    const handleValidate = (values: BotPushServiceSetting) => {
        const error: { [key: string]: string } = {}

        if (values.name === '') {
            error.name = '必须填写名称'
            setToastToastOptions((v) => ({
                ...v,
                isOpen: true,
                message: '请填写配置名称',
            }))
        }
        return error
    }

    return (
        <IonPage>
            <IonContent className='mybot-content '>
                <Header
                    title={`推送设置(${
                        location.state?.item ? '修改' : '新增'
                    })`}
                    backable
                ></Header>

                <Formik
                    initialValues={
                        location.state?.item || {
                            day_of_once: '',
                            days_of_week: [],
                            friend_reply_list: [],
                            friend_reply_object_type: 'NO_FRIEND',
                            group_reply_list: [],
                            group_reply_object_type: 'NO_GROUP',
                            msg_list: [],
                            name: '',
                            reply_frequency: '',
                            reply_time: '',
                        }
                    }
                    validate={handleValidate}
                    onSubmit={(values) => {
                        const params = { ...values }
                        if (values.reply_frequency === '') {
                            params.reply_time = ''
                        }
                        savePushServicesItem(values).then(() => {
                            history.goBack()
                        })
                    }}
                    render={({
                        values,
                        setFieldValue,
                        setValues,
                        handleSubmit,
                    }) => {
                        console.log(values)
                        return (
                            <Form onSubmit={handleSubmit}>
                                <PushServiceName
                                    value={values.name}
                                    onChange={(v) => setFieldValue('name', v)}
                                />
                                <div className='newsBotItem'>
                                    <p>推送范围</p>
                                    <div>
                                        <RadioItem
                                            className='contact-radio-item'
                                            label='无'
                                            selected={
                                                values.group_reply_object_type ===
                                                'NO_GROUP'
                                            }
                                            onSelect={() => {
                                                setFieldValue(
                                                    'group_reply_object_type',
                                                    'NO_GROUP'
                                                )
                                            }}
                                        />
                                        <RadioItem
                                            className='contact-radio-item'
                                            label='全部群'
                                            selected={
                                                values.group_reply_object_type ===
                                                'GROUP_ALL'
                                            }
                                            onSelect={() => {
                                                setFieldValue(
                                                    'group_reply_object_type',
                                                    'GROUP_ALL'
                                                )
                                            }}
                                        />
                                        <RadioItem
                                            className='contact-radio-item'
                                            label='指定群'
                                            selected={
                                                values.group_reply_object_type ===
                                                'GROUP_LIST'
                                            }
                                            onSelect={() =>
                                                setFieldValue(
                                                    'group_reply_object_type',
                                                    'GROUP_LIST'
                                                )
                                            }
                                        />
                                        <PushServiceContactList
                                            isShow={showGroup}
                                            value={values.group_reply_list}
                                            onClose={(l) => {
                                                if (l) {
                                                    setValues({
                                                        ...values,
                                                        group_reply_list: l,
                                                    })
                                                }
                                                setShowGroup(false)
                                            }}
                                            type='GROUP'
                                        />

                                        {values.group_reply_object_type ===
                                            'GROUP_LIST' && (
                                            <div className='newsBotHeadList'>
                                                {values.group_reply_list &&
                                                    values.group_reply_list
                                                        .slice(0, 6)
                                                        .map((item) => (
                                                            <img
                                                                className='newsBotItemIcon'
                                                                src={
                                                                    item.head_url
                                                                }
                                                                key={item.uid}
                                                                alt='heardPictrue'
                                                            />
                                                        ))}
                                                <div className='newsBotHeadList'>
                                                    <img
                                                        className='newsBotItemIcon'
                                                        src={ContactAddIcon}
                                                        alt='icon'
                                                        onClick={() =>
                                                            setShowGroup(true)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='newsBotItem'>
                                    <p>好友</p>
                                    <RadioItem
                                        className='contact-radio-item'
                                        label='无'
                                        selected={
                                            values.friend_reply_object_type ===
                                            'NO_FRIEND'
                                        }
                                        onSelect={() => {
                                            setFieldValue(
                                                'friend_reply_object_type',
                                                'NO_FRIEND'
                                            )
                                        }}
                                    />
                                    <RadioItem
                                        className='contact-radio-item'
                                        label='全部好友'
                                        selected={
                                            values.friend_reply_object_type ===
                                            'FRIEND_ALL'
                                        }
                                        onSelect={() => {
                                            setFieldValue(
                                                'friend_reply_object_type',
                                                'FRIEND_ALL'
                                            )
                                        }}
                                    />
                                    <RadioItem
                                        className='contact-radio-item'
                                        label='指定好友'
                                        selected={
                                            values.friend_reply_object_type ===
                                            'FRIEND_LIST'
                                        }
                                        onSelect={() =>
                                            setFieldValue(
                                                'friend_reply_object_type',
                                                'FRIEND_LIST'
                                            )
                                        }
                                    />

                                    <PushServiceContactList
                                        isShow={shwoFriend}
                                        value={values.friend_reply_list}
                                        onClose={(l) => {
                                            if (l) {
                                                setValues({
                                                    ...values,
                                                    friend_reply_list: l,
                                                })
                                            }
                                            setShowFriend(false)
                                        }}
                                        type='FRIEND'
                                    />
                                    {values.friend_reply_object_type ===
                                        'FRIEND_LIST' && (
                                        <div className='newsBotHeadList'>
                                            {values.friend_reply_list &&
                                                values.friend_reply_list
                                                    .slice(0, 6)
                                                    .map((item) => (
                                                        <img
                                                            className='newsBotItemIcon'
                                                            src={item.head_url}
                                                            key={item.uid}
                                                            alt='heardPictrue'
                                                        />
                                                    ))}
                                            <img
                                                className='newsBotItemIcon'
                                                src={ContactAddIcon}
                                                alt='icon'
                                                onClick={() =>
                                                    setShowFriend(true)
                                                }
                                            />
                                        </div>
                                    )}
                                </div>

                                <PushServiceTime
                                    time={values.reply_time}
                                    onChangeTime={(t) =>
                                        setFieldValue(
                                            'reply_time',
                                            dayjs(t).format('HH:mm') + ':00'
                                        )
                                    }
                                />

                                <div className='newsBotItem'>
                                    <p>推送频率</p>
                                    <div className='newBotItemOption'>
                                        <RadioItem
                                            className='contact-radio-item'
                                            label='关'
                                            selected={
                                                values.reply_frequency === ''
                                            }
                                            onSelect={() => {
                                                setFieldValue(
                                                    'reply_frequency',
                                                    ''
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className='newBotItemOption'>
                                        <RadioItem
                                            className='contact-radio-item'
                                            label='每天'
                                            selected={
                                                values.reply_frequency ===
                                                'DAILY'
                                            }
                                            onSelect={() => {
                                                setFieldValue(
                                                    'reply_frequency',
                                                    'DAILY'
                                                )
                                            }}
                                        />
                                    </div>
                                    <div className='newBotItemOption'>
                                        <RadioItem
                                            className='contact-radio-item'
                                            selected={
                                                values.reply_frequency ===
                                                'WEEKLY'
                                            }
                                            label={
                                                <IonSelect
                                                    className='newBotTimeWeek'
                                                    placeholder='每周'
                                                    value={values.days_of_week}
                                                    okText='确定'
                                                    cancelText='取消'
                                                    onIonChange={(e) => {
                                                        setFieldValue(
                                                            'days_of_week',
                                                            e.detail.value
                                                        )
                                                    }}
                                                    multiple
                                                >
                                                    <IonSelectOption value='mon'>
                                                        周一
                                                    </IonSelectOption>
                                                    <IonSelectOption value='tue'>
                                                        周二
                                                    </IonSelectOption>
                                                    <IonSelectOption value='wed'>
                                                        周三
                                                    </IonSelectOption>
                                                    <IonSelectOption value='thu'>
                                                        周四
                                                    </IonSelectOption>
                                                    <IonSelectOption value='fri'>
                                                        周五
                                                    </IonSelectOption>
                                                    <IonSelectOption value='sat'>
                                                        周六
                                                    </IonSelectOption>
                                                    <IonSelectOption value='sun'>
                                                        周日
                                                    </IonSelectOption>
                                                </IonSelect>
                                            }
                                            onSelect={() =>
                                                setFieldValue(
                                                    'reply_frequency',
                                                    'WEEKLY'
                                                )
                                            }
                                        />
                                    </div>

                                    <div className='newBotItemOption'>
                                        <RadioItem
                                            className='contact-radio-item'
                                            selected={
                                                values.reply_frequency ===
                                                'ONCE'
                                            }
                                            label={
                                                <IonDatetime
                                                    placeholder={
                                                        values.day_of_once ||
                                                        '指定日期'
                                                    }
                                                    cancelText='取消'
                                                    doneText='确定'
                                                    displayFormat='YYYY-MM-DD'
                                                    onIonChange={(e) => {
                                                        setFieldValue(
                                                            'day_of_once',
                                                            dayjs(
                                                                e.detail.value!
                                                            ).format(
                                                                'YYYY-MM-DD'
                                                            )
                                                        )
                                                    }}
                                                />
                                            }
                                            onSelect={() =>
                                                setFieldValue(
                                                    'reply_frequency',
                                                    'ONCE'
                                                )
                                            }
                                        />
                                    </div>
                                </div>

                                <div className='newsBotItem'>
                                    <p>消息内容</p>
                                    {values.msg_list.map((v, i) => (
                                        <div
                                            key={i}
                                            className='botPushServiceDetailMsgItem'
                                        >
                                            <input
                                                className='botPushServiceDetailInput'
                                                value={v.msg_body.content}
                                                onChange={(e) => {
                                                    const tmp = [
                                                        ...values.msg_list,
                                                    ]
                                                    tmp[i].msg_body.content =
                                                        e.target.value
                                                    setFieldValue(
                                                        'msg_list',
                                                        tmp
                                                    )
                                                }}
                                            />
                                            <img
                                                src={DeleteIcon}
                                                alt='del icon'
                                                onClick={() => {
                                                    const tmp = [
                                                        ...values.msg_list,
                                                    ]
                                                    tmp.splice(i, 1)
                                                    setFieldValue(
                                                        'msg_list',
                                                        tmp
                                                    )
                                                }}
                                            />
                                        </div>
                                    ))}

                                    <div
                                        className='botPushServiceDetailAddIcon'
                                        onClick={() =>
                                            setFieldValue('msg_list', [
                                                ...values.msg_list,
                                                {
                                                    msg_body: {
                                                        msg_type: 'text',
                                                        content: '',
                                                    },
                                                },
                                            ])
                                        }
                                    >
                                        <img src={AddIcon} alt='add Item' />{' '}
                                        <span>添加消息</span>
                                    </div>
                                </div>

                                <IonButton type='submit' expand='full'>
                                    保存
                                </IonButton>
                            </Form>
                        )
                    }}
                ></Formik>
            </IonContent>
            <Toast
                {...toastOptions}
                onClose={() =>
                    setToastToastOptions((p) => ({ ...p, isOpen: false }))
                }
            />
        </IonPage>
    )
}

export default BotPushServiceDetail
